/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-22 13:50:10
 * @LastEditTime: 2019-04-04 10:38:48
 */
/* eslint-disable complexity */
/**
 * 组件名称
 * @module router
 * @desc 路由
 * @author laikt
 * @date 2019年1月11日
 * @example 路由跳转 ，路由权限控制
 * 定义 请求
 **/
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import baseRoute from "./baseRoute";
import { menuquerybyid } from "@/api/apiall";
// import * as util from "../lib/utils.js";
Vue.use(Router);
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err);
// };
//路由设置
const router = new Router({
    routes: baseRoute,
    mode: "history",
    base: process.env.BASE_URL,
    publicpath: "/",
    scrollBehavior: () => ({
        x: 0,
        y: 0
    })
});
//路由白名单
const whiteList = [
    "frame",
    "apipage",
    "apipagelist",
    "helpnav",
    "helpdetails",
    "helplist",
    "helpdetails",
    "homePage",
    "login",
    "regist",
    "forget",
    "forgetSuccess",
    "regAgreement",
    "apidetlist",
    "apipagelist",
    "signature",
    "errorCode",
    "sdkdownload"
]; // no redirect whitelist
router.beforeEach((to, from, next) => {
    store.dispatch("setHistory", to.query.id);
    //
    /*menuquerybyid({
        id: to.query.id,
        platform: "1"
    }).then(res => {
        if (res.status == 2000) {
            let meta = document.querySelector(".meta1");
            // meta.name = "keywords";
            meta.content = res.data.keywords;
            let meta1 = document.querySelector(".meta2");
            // meta1.name = "description";
            meta1.content = res.data.description;
            document.title = res.data.seoTitle;
        }
    });*/
    next();
});
// // 路由守卫
// router.beforeEach((to, from, next) => {
//     // console.log(store.getters.islogin);
//     if (store.getters.islogin) {
//         let roles = store.getters.roles; // note: roles must be a array! such as: ['editor','develop']
//         // debugger;
//         // console.log(store.getters.addRouters);

//         if (store.getters.addRouters.length === 0) {
//             store.dispatch("GenerateRoutes", { roles }).then(() => {
//                 // 根据roles权限生成可访问的路由表
//                 router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
//                 next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//             });
//         } else if (store.getters.addRouters.length > 0) {
//             // console.log(store.getters.isPrimary);
//             // console.log(to);
//             if (store.getters.isPrimary === 0 && to.path === "/subactManage") {
//                 return false;
//             }
//             next();
//         } else {
//             next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//         }
//     } else {
//         /* has no loginStatus is false*/
//         if (whiteList.indexOf(to.name) !== -1) {
//             // 在免登录白名单，直接进入
//             next();
//         } else {
//             next("/login"); // 否则全部重定向到登录页
//         }
//     }
// });
// router.beforeEach((to, from, next) => {
//     store.dispatch("GenerateRoutes", { roles }).then(() => {
//         //                 // 根据roles权限生成可访问的路由表
//         //                 router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
//         //                 next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//         //             });
//     next();
// });
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
export default router;
